// FAQ Accordion block view script
// This block uses inner blocks (WYSIWYG and Accordion) that handle their own functionality
// No additional JavaScript needed for the parent container
